export function setSnackbar(message, closeTime, type) {
  return {
    type: 'SET_SNACKBAR',
    payload: {
      snackbar_State: true,
      snackbar_Message: message,
      snackbar_HideTime: closeTime,
      snackbar_Type: type
    }
  }
}

export function showAddItemModal(val) {
  return {
    type: 'SHOW_ADD_ITEM_MODAL',
    payload: {
      showAddItemModal: val
    }
  }
}

export function setFavoritesCategory(val) {
  return {
    type: 'SET_FAVORITES_CATEGORY',
    payload: {
      addItemFavoritesCategory: val
    }
  }
}

export function editScreenAddIngredient(mods) {
  // mod example: {showAddIngredientsModal: true, editScreenAddIngredient: true}
  return {
    type: 'EDIT_SCREEN_UPDATE_ADD_INGREDIENT',
    payload: mods
  }
}

export function showAddIngredientsModal(val, props) {

  if (props) {
    return {
      type: 'SHOW_ADD_INGREDIENTS_MODAL',
      payload: {
        showAddIngredientsModal: val,
        currentRecipe: props,
        addItemFavoritesCategory: 'food',
      }
    }
  } else {
    return {
      type: 'SHOW_ADD_INGREDIENTS_MODAL',
      payload: {
        showAddIngredientsModal: val,
        addItemFavoritesCategory: 'food',
      }
    }
  }
  
}

export function closeAddIngredientsModal() {
  return {
    type: 'SHOW_ADD_INGREDIENTS_MODAL',
    payload: {
      showAddIngredientsModal: false,
      addItemFavoritesCategory: 'recipe',
    }
  }
}

export function setAddItemCategory(val) {
  return {
    type: 'SET_ADD_ITEM_CATEGORY',
    payload: {
      addItemCategory: val
    }
  }
}

export function completeGuide() {
  return {
    type: 'COMPLETE_GUIDE',
    payload: {
      completedGuide: '1'
    }
  }
}

export function showSnackbar(val) {
  return {
    type: 'SHOW_SNACKBAR',
    payload: {
      snackbar_State: val
    }
  }
}

export function showSidebar(val) {
  return {
    type: 'SHOW_SIDEBAR',
    payload: {
      showSidebar: val
    }
  }
}

export function showModal(modalName, val) {
  return {
    type: 'SHOW_MODAL',
    payload: {
      [modalName]: val
    }
  }
}

export function showEditWeighInModal(showModal, index) {
  return {
    type: 'SHOW_EDIT_WEIGHIN_MODAL',
    payload: {
      showEditWeighInModal: showModal,
      selectedWeighInIndex: index,
    }
  }
}

export function showEditAddWeighInModal(showModal, index) {
  return {
    type: 'SHOW_EDITADD_WEIGHIN_MODAL',
    payload: {
      showEditAddWeighInModal: showModal,
      selectedWeighInIndex: index
    }
  }
}

export function showEditCheckWeighInModal(showModal, index) {
  return {
    type: 'SHOW_EDITCHECK_WEIGHIN_MODAL',
    payload: {
      showEditCheckWeighInModal: showModal,
      selectedWeighInIndex: index
    }
  }
}

export function showBfCalcModal(showModal) {
  return {
    type: 'SHOW_BF_CALC_MODAL',
    payload: {
      showBfCalcModal: showModal
    }
  }
}

export function showBillingModal(showModal) {
  return {
    type: 'SHOW_BILLING_MODAL',
    payload: {
      showBillingModal: showModal
    }
  }
}

export function showPortalConsentModal(showModal) {
  return {
    type: 'SHOW_PORTAL_CONSENT_MODAL',
    payload: {
      showPortalConsentModal: showModal
    }
  }
}

export function displayNotificationMessage(coaching) {
  return {
    type: 'DISPLAY_NOTIFICATION_MESSAGE',
    payload: {
      coaching: coaching,
    }
  }
}

export function displayPart7Message(msg) {
  return {
    type: 'DISPLAY_PART7_MESSAGE',
    payload: {
      message: msg
    }
  }
}

export function enableResumeGoalChangeMode(val) {
  return {
    type: 'ENABLE_RESUME_GOAL_CHANGE_MODE',
    payload: {
      resumeGoalChangeMode: val
    }
  }
}

export function showEditNowModal(val) {
  return {
    type: 'SHOW_EDIT_NOW_MODAL',
    payload: {
      showEditNowModal: val,
    }
  }
}

export function updateEditNowType(type) {
  return {
    type: 'SHOW_EDIT_NOW_MODAL',
    payload: {
      editNowModalType: type
    }
  }
}

export function setShowTargetReached(val, coaching) {
  return {
    type: 'SHOW_TARGET_REACHED_MODAL',
    payload: {
      showTargetReached: val,
      targetReachedMessageId: (val && coaching.id) ? coaching.id : 0,
    }
  }
}

export function setFriendsTab(val) {
  return {
    type: 'UPDATE_DASHBOARD_STORE',
    payload: {
      friendsTab: val
    }
  }
}

export function setDashboardStore(key, val) {
  return {
    type: 'UPDATE_DASHBOARD_STORE',
    payload: {
      [key]: val
    }
  }
}

export function closeOpeningModal() {
  return {
    type: 'CLOSE_OPENING_MODAL'
  }
}

export function logout() {
  window.localStorage.removeItem('jwt');
  window.localStorage.removeItem('streamChatUser');
  window.localStorage.removeItem('streamChatToken');
  return {
    type: 'LOGOUT'
  };
}

export function setSelectedDailyWeight(val) {
  return {
    type: 'UPDATE_SELECTED_DAILYWEIGHT',
    payload: {
      selectedDailyWeight: val
    }
  }
}